import { useTranslation } from "react-i18next";

import CustomModal from "../../../../packages/CustomModal";

import TrainFileUsageTable from "../../../../components/TrainFileUsageTable/TrainFileUsageTable";

import { TRAIN_USAGE_MODAL_ACTIONS } from "../../../../constants/global.constants";

const FileReplaceDeleteModal = ({
  isOpen,
  trainUsageModalAction,
  uploadedFiles,
  allTrainsStatus,
  selectedActionFileId,
  onModalClose,
  onAppendFromTrainUsageTable,
}) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  const isDeleteAction =
    trainUsageModalAction === TRAIN_USAGE_MODAL_ACTIONS.DELETE;

  return (
    <CustomModal
      header={
        isDeleteAction
          ? t("trainfileusagetable.deleteFile")
          : t("trainfileusagetable.replaceFile")
      }
      onModalClose={onModalClose}
      confirmBtn={
        isDeleteAction
          ? t("trainfileusagetable.deleteFile")
          : t("trainfileusagetable.replaceFile")
      }
      cancelBtn={t("ValueStrings.cancel")}
      width="980px"
    >
      <TrainFileUsageTable
        uploadedFiles={uploadedFiles}
        allTrainsStatus={allTrainsStatus}
        plantFileId={selectedActionFileId}
        showAppendColumn={!isDeleteAction}
        setTempSelectedTrain={
          isDeleteAction ? undefined : onAppendFromTrainUsageTable
        }
      />
    </CustomModal>
  );
};

export default FileReplaceDeleteModal;
